import MyTeamAttendanceComponent from "../components/MyTeamAttendance";
import useMyTeamAttendance from "../hooks/useMyTeamAttendance";

function MyTeamAttendance() {
  const useMyTeamAttendanceProps = useMyTeamAttendance();
  return <MyTeamAttendanceComponent {...useMyTeamAttendanceProps} />;
}

export default MyTeamAttendance;
